<template>
	<div class="scrollable only-y">
		<div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text"><i class="mdi mdi-file-account widget-icon accent-text fs-30"></i> {{ capitalizeFirstLetter(detailAllLogAdmin.nameAdmin) }}</h2>
			</div>
		</div>
		<el-card>
			<el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">
			  <el-tab-pane label="Log Consumen" name="consumen">
				<div>
					<el-table :data="detailLogAdmin" style="width: 100%;" v-loading="loadingDetail" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="date" label="Updated At" width="200" fixed="left">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.date }}</p>
							</template>
						</el-table-column>

						<el-table-column prop="log" label="Log" width="150">
							<template slot-scope="props">
								<el-tag
								v-if="props.row.log == 'create'"
								type="primary"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">CREATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'update'"
								type="warning"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">UPDATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'delete'"
								type="danger"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">DELETE</span>
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="desc" label="Description">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{props.row.desc}}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			  </el-tab-pane>
			  <el-tab-pane label="Log Product" name="product">
				<div>
					<el-table :data="detailLogAdmin" style="width: 100%;" v-loading="loadingDetail" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="date" label="Updated At" width="200" fixed="left">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.date }}</p>
							</template>
						</el-table-column>

						<el-table-column prop="log" label="Log" width="150">
							<template slot-scope="props">
								<el-tag
								v-if="props.row.log == 'create'"
								type="primary"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">CREATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'update'"
								type="warning"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">UPDATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'delete'"
								type="danger"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">DELETE</span>
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="desc" label="Description">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{props.row.desc}}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			  </el-tab-pane>
			  <el-tab-pane label="Log HSM Template" name="template">
				<div>
					<el-table :data="detailLogAdmin" style="width: 100%;" v-loading="loadingDetail" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="date" label="Updated At" width="200" fixed="left">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.date }}</p>
							</template>
						</el-table-column>

						<el-table-column prop="log" label="Log" width="150">
							<template slot-scope="props">
								<el-tag
								v-if="props.row.log == 'create'"
								type="primary"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">CREATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'update'"
								type="warning"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">UPDATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'delete'"
								type="danger"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">DELETE</span>
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="desc" label="Description">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{props.row.desc}}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			  </el-tab-pane>
			  <el-tab-pane label="Log WA Connect" name="waConnect">
				<div>
					<el-table :data="detailLogAdmin" style="width: 100%;" v-loading="loadingDetail" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="date" label="Updated At" width="200" fixed="left">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.date }}</p>
							</template>
						</el-table-column>

						<el-table-column prop="log" label="Log" width="150">
							<template slot-scope="props">
								<el-tag
								v-if="props.row.log == 'create'"
								type="primary"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">CREATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'update'"
								type="warning"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">UPDATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'delete'"
								type="danger"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">DELETE</span>
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="desc" label="Description">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{props.row.desc}}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			  </el-tab-pane>
			  <el-tab-pane label="Log Notification" name="notification">
				<div>
					<el-table :data="detailLogAdmin" style="width: 100%;" v-loading="loadingDetail" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="date" label="Updated At" width="200" fixed="left">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.date }}</p>
							</template>
						</el-table-column>

						<el-table-column prop="log" label="Log" width="150">
							<template slot-scope="props">
								<el-tag
								v-if="props.row.log == 'create'"
								type="primary"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">CREATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'update'"
								type="warning"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">UPDATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'delete'"
								type="danger"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">DELETE</span>
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="desc" label="Description">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{props.row.desc}}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			  </el-tab-pane>
			  <el-tab-pane label="Log Admin Management" name="admin_manage">
				<div>
					<el-table :data="detailLogAdmin" style="width: 100%;" v-loading="loadingDetail" element-loading-text="Loading..." element-loading-spinner="el-icon-loading">
						<el-table-column prop="date" label="Updated At" width="200" fixed="left">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{ props.row.date }}</p>
							</template>
						</el-table-column>

						<el-table-column prop="log" label="Log" width="150">
							<template slot-scope="props">
								<el-tag
								v-if="props.row.log == 'create'"
								type="primary"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">CREATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'update'"
								type="warning"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">UPDATE</span>
								</el-tag>
								<el-tag
								v-if="props.row.log == 'delete'"
								type="danger"
								size="large"
								class="mt-10"
								>
									<span style="font-weight:bold;">DELETE</span>
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="desc" label="Description">
							<template slot-scope="props">
								<p style="font-weight:bold;">{{props.row.desc}}</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			  </el-tab-pane>
			</el-tabs>
			<br>
			<div>
				<el-button @click="$router.push('/log_admin')" style="float: left; margin-bottom: 20px;" class="button">Back</el-button>
			</div>
		</el-card>
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
const _ = require('lodash')
const moment = require('moment')

export default {
	name: 'LogAdminDetail',
	data () {
		return {
			detailLogAdmin:[],
			detailAllLogAdmin:[],
			loadingDetail: true,
			currentPage: 1,
			formLabelWidth: '200px',
			timeout: null,
			activeTab: "consumen"
		}
	},
	methods: {
		getBodyText(components){
			let c = components.find(v => v.type.toLowerCase() == "body")
			if(c){
				return c.text
			} else {
				return ""
			}
		},
		tabClick(tab){
			this.detailLog()
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		formatDate(val, format){
			if(val) return moment(val).format(format)
			else return "-"
		},
		async detailLog(){
            this.loadingDetail = true
            let adminId = this.$route.params.adminId
            await api({
                url: config.baseApi + 'log_admin/' + adminId,
                method: 'get'
            })
            .then(res => {
				// this.$swal(this.$t('error'), this.$t('error_text'), "error")
				console.log(res);
				this.detailAllLogAdmin = res.data.data
				switch (this.activeTab) {
					case 'consumen':
						this.detailLogAdmin = res.data.data.log_consumen
						this.detailLogAdmin.forEach((el,i)=>{
							switch (el.log) {
								case 'create':
									if(el.add_service_user){
										this.detailLogAdmin[i].desc = `Add Service User : ${el.add_service_user}`
									}
									else if(el.add_service_helpdesk){
										this.detailLogAdmin[i].desc = `Add Service Helpdesk : ${el.add_service_helpdesk}`
									}
									else if(el.add_new_division){
										this.detailLogAdmin[i].desc = `Add New Division : ${el.add_new_division}`
									}
								break;
								case 'update':
									if(el.update_customer_name){
										this.detailLogAdmin[i].desc = `Update Customer : ${el.update_customer_name}`
									}
									else if(el.add_product_user){
										this.detailLogAdmin[i].desc = `Add Product User : ${el.add_product_user}`
									}
									else if(el.add_service_addtional_user){
										this.detailLogAdmin[i].desc = `Add Additional Service User : ${el.add_service_addtional_user}`
									}
									else if(el.add_product_addtional_user){
										this.detailLogAdmin[i].desc = `Add Product Service User : ${el.add_product_addtional_user}`
									}
									else if(el.revoke_account){
										this.detailLogAdmin[i].desc = `Revoke Account : ${el.revoke_account}`
									}
									else if(el.update_webhook_number){
										this.detailLogAdmin[i].desc = `Update Webhook Number : ${el.update_webhook_number}`
									}
									else if(el.update_customer_number){
										this.detailLogAdmin[i].desc = `Update Customer Number : ${el.update_customer_number}`
									}
									else if(el.member_reset_password_email){
										this.detailLogAdmin[i].desc = `Reset Password or Email : ${el.member_reset_password_email}`
									}
									else if(el.phone_number_product){
										this.detailLogAdmin[i].desc = `Update Phone Number Product : ${el.phone_number_product}`
									}
									else if(el.config_set_limit_number){
										this.detailLogAdmin[i].desc = `Config Limit Number : ${el.config_set_limit_number}`
									}
									else if(el.service_user_number){
										this.detailLogAdmin[i].desc = `Update Service User Number : ${el.service_user_number}`
									}
									else if(el.config_generate_token){
										this.detailLogAdmin[i].desc = `Config Generate Token  : ${el.config_generate_token}`
									}
									else if(el.config_rate_limit_number){
										this.detailLogAdmin[i].desc = `Config Rate Limit Number : ${el.config_rate_limit_number}`
									}
									else if(el.assign_hsm){
										this.detailLogAdmin[i].desc = `Assign HSM : ${el.assign_hsm}`
									}
									else if(el.unassign_hsm){
										this.detailLogAdmin[i].desc = `Unassign HSM : ${el.unassign_hsm}`
									}
									else if(el.update_division){
										this.detailLogAdmin[i].desc = `Update Division : ${el.update_division}`
									}
									else if(el.delete_division){
										this.detailLogAdmin[i].desc = `Delete Division : ${el.delete_division}`
									}
									else if(el.add_template_division){
										this.detailLogAdmin[i].desc = `Add Template Division : ${el.add_template_division}`
									}
									else if(el.delete_template_division){
										this.detailLogAdmin[i].desc = `Delete Template Division : ${el.delete_template_division}`
									}
								break;
								case 'delete':
									if(el.member_remove_user_email){
										this.detailLogAdmin[i].desc = `Remove User Email : ${el.member_remove_user_email}`
									}
									else if(el.phone_number_product){
										this.detailLogAdmin[i].desc = `Remove Number Product : ${el.phone_number_product}`
									}
									else if(el.service_user_number){
										this.detailLogAdmin[i].desc = `Remove Service User Number : ${el.service_user_number}`
									}
									else if(el.delete_service_number){
										this.detailLogAdmin[i].desc = `Delete Service Number : ${el.delete_service_number}`
									}
									else if(el.delete_additional_service_name){
										this.detailLogAdmin[i].desc = `Delete Additional Service Number : ${el.delete_additional_service_name}`
									}
								break;
							}
						})
					break;
					case 'product':
						this.detailLogAdmin = res.data.data.log_product
						this.detailLogAdmin.forEach((el,i)=>{
							switch (el.log) {
								case 'create':
									if(el.product_name) this.detailLogAdmin[i].desc = `Add New Product : ${el.product_name}`
								break;
								case 'update':
									if(el.product_name) this.detailLogAdmin[i].desc = `Update Product : ${el.product_name}`
								break;
								case 'delete':
									if(el.product_name) this.detailLogAdmin[i].desc = `Delete Product : ${el.product_name}`
								break;
							}
						})
					break;
					case 'template':
					this.detailLogAdmin = res.data.data.log_template
					this.detailLogAdmin.forEach((el,i)=>{
						switch (el.log) {
							case 'create':
								if(el.template_name) this.detailLogAdmin[i].desc = `Add New HSM Template : ${el.template_name}`
							break;
							case 'update':
								if(el.template_name_space) {
									this.detailLogAdmin[i].desc = `Update Template Name Space : ${el.template_name_space}`
								}
								else{
									this.detailLogAdmin[i].desc = `Update Template : ${el.template_name}`
								}
							break;
						}
					})
					break;
					case 'waConnect':
					this.detailLogAdmin = res.data.data.log_waConnect
					this.detailLogAdmin.forEach((el,i)=>{
						switch (el.log) {
							case 'create':
								if(el.service_name) this.detailLogAdmin[i].desc = `Add New Service Whatsapp Connect : ${el.service_name}`
							break;
						}
					})
					break;
					case 'notification':
					this.detailLogAdmin = res.data.data.log_notification
					this.detailLogAdmin.forEach((el,i)=>{
						switch (el.log) {
							case 'create':
								if(el.title) this.detailLogAdmin[i].desc = `Add New Notification : ${el.title}`
							break;
							case 'update':
								if(el.title) this.detailLogAdmin[i].desc = `Update Notification : ${el.title}`
							break;
							case 'delete':
								if(el.title) this.detailLogAdmin[i].desc = `Delete Notification : ${el.title}`
							break;
						}
					})
					break;
					case 'admin_manage':
					this.detailLogAdmin = res.data.data.log_manageAdmin
					this.detailLogAdmin.forEach((el,i)=>{
						switch (el.log) {
							case 'create':
								if(el.admin) this.detailLogAdmin[i].desc = `Add New Admin : ${el.admin}`
							break;
							case 'update':
								if(el.admin) this.detailLogAdmin[i].desc = `Update Admin : ${el.admin}`
							break;
							case 'delete':
								if(el.admin) this.detailLogAdmin[i].desc = `Delete Admin : ${el.admin}`
							break;
						}
					})
					break;
				}
				this.loadingDetail = false
            })
            .catch(err => {
				console.log('error', err);
				this.loadingDetail = false
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
            })
        },
		// async paginateLogDetail(page){
		// 	this.currentPage = page
		// },
	},
	created() {
		this.detailLog()
	},
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
